(() => {
  const theme = window.theme || { strings: {}, routes: {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const Theme = {
    openDialog(dialog) {
      if (!dialog || dialog.open) return;
      dialog.classList.remove('is-closing');
      dialog.showModal();
      document.documentElement.classList.add('is-locked');
    },

    closeDialog(dialog) {
      if (!dialog || !dialog.open) return;
      if (reduceMotion.matches) {
        dialog.close();
        return;
      }
      dialog.classList.add('is-closing');
      window.setTimeout(() => {
        dialog.classList.remove('is-closing');
        dialog.close();
      }, 160);
    },

    toast(message) {
      const region = document.querySelector('[data-toast-region]');
      if (!region || !message) return;
      const toast = document.createElement('div');
      toast.className = 'toast';
      toast.textContent = message;
      region.appendChild(toast);
      window.setTimeout(() => {
        toast.classList.add('is-leaving');
        window.setTimeout(() => toast.remove(), 200);
      }, 5000);
    },
  };

  window.Theme = Theme;

  const initHeader = () => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  window.addEventListener('scroll', initHeader, { passive: true });

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.1 }
        )
      : null;

  const initReveal = (root = document) => {
    const animate = observer && !(window.Shopify && window.Shopify.designMode);
    if (animate) document.documentElement.classList.add('reveal-on');
    root.querySelectorAll('[data-reveal]:not([data-reveal-ready])').forEach((el) => {
      el.setAttribute('data-reveal-ready', '');
      if (!animate || el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('is-visible');
        return;
      }
      const siblings = Array.from(el.parentElement.children).filter((child) => child.hasAttribute('data-reveal'));
      el.style.setProperty('--reveal-index', Math.min(siblings.indexOf(el), 6));
      observer.observe(el);
    });
  };

  Theme.reveal = initReveal;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      event.preventDefault();
      Theme.openDialog(document.getElementById(opener.getAttribute('data-dialog-open')));
      return;
    }

    const closer = event.target.closest('[data-dialog-close]');
    if (closer) {
      Theme.closeDialog(closer.closest('dialog'));
      return;
    }

    if (event.target instanceof HTMLDialogElement && event.target.hasAttribute('data-dialog')) {
      Theme.closeDialog(event.target);
      return;
    }

    const coupon = event.target.closest('[data-coupon]');
    if (coupon) {
      const code = coupon.getAttribute('data-coupon');
      const status = coupon.querySelector('[data-coupon-status]');
      const done = () => {
        coupon.classList.add('is-copied');
        if (status) status.textContent = theme.strings.copied;
        window.setTimeout(() => {
          coupon.classList.remove('is-copied');
          if (status) status.textContent = theme.strings.copy;
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, () => Theme.toast(theme.strings.error));
      } else {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        try {
          document.execCommand('copy');
          done();
        } catch (error) {
          Theme.toast(theme.strings.error);
        }
        field.remove();
      }
      return;
    }

    document.querySelectorAll('details[data-disclosure][open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  // Remember a manual language choice so the Spanish-browser redirect in theme.liquid never overrides it.
  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'language_code' || !submitter.value) return;
    try {
      localStorage.setItem('sk_lang_choice', submitter.value);
    } catch (error) {}
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[data-disclosure][open]').forEach((details) => {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  document.addEventListener(
    'close',
    (event) => {
      if (event.target instanceof HTMLDialogElement && !document.querySelector('dialog[open]')) {
        document.documentElement.classList.remove('is-locked');
      }
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => initReveal(event.target));

  const ready = () => {
    initHeader();
    initReveal();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
